import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../assets/apiRoutes.json";
import {
    Column,
    DataGrid,
    RequiredRule,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    Editing,
} from "devextreme-react/data-grid";
import RenderSelectBoxCell from "../../../../common/RenderCell";
import { GetFormatedDateWithTime } from '../../../../common/Utils'

import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button, SelectBox } from 'devextreme-react';
import { confirm } from 'devextreme/ui/dialog';

import axios from "axios";
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../../../common/GridLayout";

const gridKey = "A2FE0E10-F393-414A-8486-82421C5CBEB7";
function LaborTrackingTab(props) {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
        const [currentLayout, setCurrentLayout] = useState("Default");
    
        const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
        const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const allowedPageSizes = [10, 20, 100, "all"];
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const dataSource = useMemo(() => createStore({
        key: 'rowid',
        loadUrl: `${window._env_.REACT_APP_APIS}/${data.TransactionLaborTracking.GetLaborTrackings}`,
        insertUrl: `${window._env_.REACT_APP_APIS}/${data.TransactionLaborTracking.InsertLaborTrackings}`,
        updateUrl: `${window._env_.REACT_APP_APIS}/${data.TransactionLaborTracking.UpdateLaborTrackings}`,
        deleteUrl: `${window._env_.REACT_APP_APIS}/${data.TransactionLaborTracking.DeleteLaborTrackings}`,
        loadParams:{
            sourceId:props.sourceId,
            sort: JSON.stringify([{ selector: "identityId", desc: false },{ selector: "keysequence", desc: false }]) 
        },
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
            };
        }
    }), [props.sourceId]);
    const handleCellValueChanged = (data) => {

        setSelectedItemKeys(data.selectedRowKeys);
    }
    const handleEditorPreparing = (e) => {
        if (e.dataField === "endDate") {
            e.editorOptions.onValueChanged = (args) => {
                const newEndDate = args.value;
                const startDate = e.row.data.startDate;

                if (newEndDate && startDate && new Date(newEndDate) < new Date(startDate)) {
                   let conf= confirm("End Date Is Less Than Start Date. Do You Wish To Continue?", "Confirm");
                   conf.done((result) => {
                        if (result) {
                            e.setValue(newEndDate); // Apply change if confirmed
                        } else {
                            e.component.cancelEditData(); // Revert change
                        }
                    });
                } else {
                    e.setValue(newEndDate);
                }
            };
        }
    };
    const deleteRecords = useCallback(() => {

        let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                dataGrid.current.instance().beginCustomLoading("Deleting");
                axios.post
                    (
                        `${window._env_.REACT_APP_APIS}/${data.TransactionLaborTracking.DeleteLaborTrackings}`,
                        selectedItemKeys,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                            },
                        }
                    )
                    .then((res) => {
                        dataGrid.current.instance().endCustomLoading();
                        dataGrid.current.instance().refresh();
                    })
                    .catch((err) => {
                        dataGrid.current.instance().endCustomLoading();
                        alert(err, "Error");
                    });

            }
        });

    }, [selectedItemKeys]);
    const rowInserting=(e)=>{
        e.data['rSourceId'] = props.sourceId;
        e.data['rCustomer'] = props.rCustomer;
    }
    const rowInserted=(e)=>{
        e.component.columnOption('keySequence', {  
            sortOrder: 'asc',  
            sortIndex: 0  
          });
    }
    const rowUpdating=(e)=>{
        e.newData['rSourceId'] = props.sourceId;
        e.newData['rCustomer'] = props.rCustomer;
    }
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={dataSource}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                onSelectionChanged={handleCellValueChanged}
                onEditorPreparing={handleEditorPreparing}
                onRowInserting={rowInserting}
                onRowUpdating={rowUpdating}
                onRowInserted={rowInserted}
                className="GridHeightTabPanel-with-toolbar"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                repaintChangesOnly={true}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                                <StateStoring
                                    enabled={true}
                                    type="custom"
                                    customLoad={loadState}
                                    storageKey={gridKey}
                                    customSave={saveState}
                                />
                <Export enabled={true} allowExportSelectedData={true} />
                <Paging defaultPageSize={10} />
                <Editing
                 mode="cell"
                 refreshMode="repaint"
                 newRowPosition="last"
                 allowUpdating={!props.isCommittedTransaction}
                    allowAdding={!props.isCommittedTransaction}
                 
                 />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <Selection mode="multiple" />
                <Export enabled={true} allowExportSelectedData={true} />
                <Paging enabled={true} />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <Column dataField="keySequence" caption='Key Sequence' visible={false} allowSorting={false} showInColumnChooser={false}/>
                <Column dataField="identityId" caption="Worker Id"allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetWorkers`,
                            key: "id",
                            displayExpr: "name",
                            valueExpr: "id",
                            accessToken: accessToken,
                            defaultValue: cellElement.data.rWorker,
                            sort: [{ selector: "name", desc: false }],
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.identityId = newValue.text;
                        rowData.rWorker = newValue.value;
                        if(rowData.rowid===undefined){
                            const now = new Date();
                            rowData.startDate =GetFormatedDateWithTime(now);
                        }

                    }}
                >
                        <RequiredRule message="Worker Id is required" />
                </Column>
                <Column dataField="name" caption="Name" allowEditing={false} allowSorting={false}/>
                <Column
                    dataField="startDate"
                    caption="Start Date Time"
                    dataType="datetime"
                    format="MM/dd/yyyy hh:mm:ss a"
                    allowSorting={false}
                    editorOptions={{
                        type: "datetime",
                        displayFormat: "MM/dd/yyyy hh:mm:ss a"
                    }}
                />
                <Column
                    dataField="endDate"
                    caption="End Date Time"
                    dataType="datetime"
                    format="MM/dd/yyyy hh:mm:ss a"
                    allowSorting={false}
                    editorOptions={{
                        type: "datetime",
                        displayFormat: "MM/dd/yyyy hh:mm:ss a"
                    }}
                />


                <Column
                    dataField="elapsedHours"
                    caption="Elapsed Hours"
                    dataType="number"
                    allowEditing={false}
                    allowSorting={false}
                />
                <Column
                    dataField="elapsedMinutes"
                    caption="Elapsed Minutes"
                    dataType="number"
                    allowEditing={false}
                    allowSorting={false}
                />
                <Column dataField="activity" caption="Ca Activity" dataType="string" allowSorting={false} editCellRender={(cellElement) =>
                    RenderSelectBoxCell({
                        loadUrl: `${window._env_.REACT_APP_APIS}/ca/Lookup/GetCAActivity`,
                        key: "id",
                        displayExpr: "name",
                        valueExpr: "id",
                        accessToken: accessToken,
                        sort: [{ selector: "name", desc: false }],
                        defaultValue: cellElement.data.rCaactivity,
                        onValueChangeCallback: (value, text) => {
                            cellElement.setValue(({ value, text }));
                        },
                    })
                }
                    setCellValue={(rowData, newValue) => {
                        rowData.activity = newValue.text;
                        rowData.rCaactivity = newValue.value;
                    }} />
                <Column
                    dataField="workUnitQuantity"
                    caption="Work Quantity"
                    dataType="number"
                    visible={false}
                    allowSorting={false}
                />
                <Column visible={false} dataField="comment" caption="Comment" dataType="string"
                  editorType="dxTextArea"
                  editorOptions={{ 
                      autoResizeEnabled: true 
                  }}/>
                <Column visible={false} dataField="userDefinedCode1" caption="Code1" dataType="string" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.WMLookup.GetCodes}`,
                            loadParams: {
                                codeType: function () {
                                    return 'A4';
                                }
                            },
                            key: "name",
                            displayExpr: "name",
                            valueExpr: "name",
                            accessToken: accessToken,
                            sort: [{ selector: "name", desc: false }],
                            defaultValue: cellElement.data.userDefinedCode1,
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.userDefinedCode1 = newValue.text;
                    }}
                />
                <Column visible={false} dataField="userDefinedCode2" caption="Code2" dataType="string" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.WMLookup.GetCodes}`,
                            loadParams: {
                                codeType: function () {
                                    return 'A5';
                                }
                            },
                            key: "name",
                            displayExpr: "name",
                            valueExpr: "name",
                            accessToken: accessToken,
                            sort: [{ selector: "name", desc: false }],
                            defaultValue: cellElement.data.userDefinedCode2,
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.userDefinedCode2 = newValue.text;
                    }} />
                <Column visible={false} dataField="userDefinedCode3" caption="Code3" dataType="string" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.WMLookup.GetCodes}`,
                            loadParams: {
                                codeType: function () {
                                    return 'A6';
                                }
                            },
                            key: "name",
                            displayExpr: "name",
                            valueExpr: "name",
                            accessToken: accessToken,
                            sort: [{ selector: "name", desc: false }],
                            defaultValue: cellElement.data.userDefinedCode3,
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.userDefinedCode3 = newValue.text;
                    }} />
                <Column visible={false} dataField="userDefinedQuantity1" caption="Quantity1" dataType="number" allowSorting={false}/>
                <Column visible={false} dataField="userDefinedQuantity2" caption="Quantity2" dataType="number" allowSorting={false}/>
                <Column visible={false} dataField="userDefinedQuantity3" caption="Quantity3" dataType="number" allowSorting={false}/>
                <Column visible={false} dataField="userDefinedReference1" caption="Reference1" dataType="string" editorOptions={{ maxLength: 50 }}allowSorting={false}/>
                <Column visible={false} dataField="userDefinedReference2" caption="Reference2" dataType="string" editorOptions={{ maxLength: 50 }}allowSorting={false}/>
                <Column visible={false} dataField="userDefinedReference3" caption="Reference3" dataType="string" editorOptions={{ maxLength: 50 }}allowSorting={false}/>

                <Column dataField="workUnitUOM" caption="Work UOM" dataType="string" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/ed/Lookup/GetEdelementcodese`,
                            loadParams: {
                                dataelementnum: function () {
                                    return '355';
                                },
                                versionid: function () {
                                    return '4010';
                                }
                            },
                            key: "name",
                            displayExpr: "name",
                            valueExpr: "name",
                            accessToken: accessToken,
                            sort: [{ selector: "name", desc: false }],
                            defaultValue: cellElement.data.workUnitUOM,
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.workUnitUOM = newValue.text;
                    }} />
                <GridToolbar>

                    <GridToolbarItem
                        name="addRowButton"
                    />
                    <GridToolbarItem location="after">
                        <Button
                            onClick={deleteRecords}
                            icon="trash"
                            disabled={!selectedItemKeys?.length || props.isCommittedTransaction == true}
                        />
                    </GridToolbarItem>
                                        <GridToolbarItem location="after">
                                            <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                        </GridToolbarItem>
                    <GridToolbarItem name="exportButton" />
                    <GridToolbarItem name="columnChooserButton" />
                </GridToolbar>
            </DataGrid>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LaborTrackingTab);